import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { getAvailableUnits, shouldShowAvailableUnits } from "@faire/retailer-visitor-shared/views/product/ProductDetails/productAvailableUnits";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { isNotUndefined } from "@faire/web--source/common/typescriptUtils";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import * as React from "react";
export var LoggedInOnlyNote = function(param) {
    var nonReturnableReason = param.nonReturnableReason, product = param.product, selectedOption = param.selectedOption;
    var strictLocalize = useStrictLocalization().strictLocalize;
    var availableUnits = getAvailableUnits(product, selectedOption);
    var showAvailableUnits = shouldShowAvailableUnits(product, availableUnits, selectedOption);
    var availableUnitsMessage = showAvailableUnits ? strictLocalize({
        id: "1EyMM9",
        defaultMessage: [
            {
                type: 6,
                value: "availableUnitsNumber",
                options: {
                    one: {
                        value: [
                            {
                                type: 0,
                                value: "Only "
                            },
                            {
                                type: 7
                            },
                            {
                                type: 0,
                                value: " left!"
                            }
                        ]
                    },
                    other: {
                        value: [
                            {
                                type: 0,
                                value: "Only "
                            },
                            {
                                type: 7
                            },
                            {
                                type: 0,
                                value: " left!"
                            }
                        ]
                    }
                },
                offset: 0,
                pluralType: "cardinal"
            }
        ]
    }, {
        availableUnitsNumber: availableUnits
    }) : undefined;
    var finalSaleMessage = nonReturnableReason ? strictLocalize({
        id: "tYZ1Tp",
        defaultMessage: [
            {
                type: 0,
                value: "Final sale. "
            },
            {
                type: 1,
                value: "nonReturnableReasonFullyTranslatedSentence"
            }
        ]
    }, {
        nonReturnableReasonFullyTranslatedSentence: nonReturnableReason
    }) : undefined;
    if (nonReturnableReason || showAvailableUnits) {
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(Spacer, {
                    height: "2x"
                }),
                /*#__PURE__*/ _jsx(Typography, {
                    children: [
                        availableUnitsMessage,
                        finalSaleMessage
                    ].filter(isNotUndefined).join(" ")
                })
            ]
        });
    }
    return null;
};
